export default __webpack_public_path__ + "static/media/favicon_bekb.ccfd82a3.ico";